import React, {useEffect, useState} from 'react';
import {Button, Container, Nav, Navbar, NavDropdown} from 'react-bootstrap';
import {FaHeadset} from 'react-icons/fa';
import {Text, Image, Platform, StyleSheet} from 'react-native';
import {GetNetworkProvider} from '../network/NetworkProvider';

export default function MainSiteHeader(props) {
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      sticky="top"
      style={{backgroundColor: 'black'}}
      variant="dark">
      <Navbar.Brand href="http://ulka.tv">
        {
          <Image
            style={styles.logoStyle}
            source={process.env.PUBLIC_URL + '/assets/ulkatvmini.png'}/>
        }
      </Navbar.Brand>
      <Navbar.Brand href="http://ulka.tv">
        {/* <Image
          style={styles.logoStyle}
          source={process.env.PUBLIC_URL + '/assets/ulkatvmini.png'}></Image> */}
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto" activeKey={Platform.OS == "web" ?  window.location.pathname : props.navigation?.state?.routeName}>
          <Nav.Link href="http://ulka.tv">Home</Nav.Link>
          <Nav.Link href="http://ulka.tv/packs">Bouquets</Nav.Link>
          <Nav.Link href="https://ulka.tv/about-us">About us</Nav.Link>
          <Nav.Link href="https://ulka.tv/privacy-policy">Privacy Policy</Nav.Link>
          <Nav.Link href="https://ulka.tv/terms-conditions">Terms &amp; Conditions</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

const styles = StyleSheet.create({
  headerStyle: {
    borderBottomWidth: 0,
    height: 50,
  },
  logoStyle: {
    height: 38,
    width: 160,
  },
  username: {
    borderRadius: '50%',
    color:'#fff',
    width: 45,
    height: 45,
    borderColor: 'transparent',
    borderStyle: 'solid',
    borderWidth: 0,
    backgroundColor: 'red',
    textAlign: 'center',
    textAlignVertical: 'center',
    justifyContent: 'center',
  },
  usernameAbbr: {
    color: '#fff',
    fontSize: 18,
  }
});
